/** Skeleton shimmer primitives. Use className to control size and shape. */

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`kilo-skeleton ${className}`} aria-hidden="true" />
}

/** One or more text-height shimmer lines. */
export function SkeletonLines({
  lines = 1,
  className = '',
}: {
  lines?: number
  className?: string
}) {
  const widths = ['w-4/5', 'w-full', 'w-3/5', 'w-11/12', 'w-2/3']
  return (
    <div className={`space-y-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`h-4 ${widths[i % widths.length]}`} />
      ))}
    </div>
  )
}

/** A card-shaped placeholder — matches BentoCard geometry. */
export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-3xl border border-kilo-border bg-kilo-card p-4 shadow-kilo-card ${className}`}
      aria-hidden="true"
    >
      <div className="space-y-3">
        <Skeleton className="h-2.5 w-20 rounded-full" />
        <Skeleton className="h-5 w-3/4" />
        <SkeletonLines lines={2} />
      </div>
    </div>
  )
}

/** A row inside a list — icon + two text lines. */
export function SkeletonRow({ className = '' }: { className?: string }) {
  return (
    <div
      className={`flex items-center gap-3 rounded-xl border border-kilo-border bg-kilo-nested p-3 ${className}`}
      aria-hidden="true"
    >
      <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-3.5 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  )
}

/** Image-area placeholder — same shape as MealImage. */
export function SkeletonImage({ className = '' }: { className?: string }) {
  return <Skeleton className={`rounded-xl ${className}`} />
}
